import React from 'react';
import PropTypes from 'prop-types';
import {Navigate, useParams} from 'react-router-dom';
import {buildPath} from '@tenant/core/routes';

/**
 * Resolves an alias path to its canonical route, carrying params across.
 *
 * `/v/7` -> `/viewings/7`. Generalised from the old NavigateViewingsFeature,
 * which hardcoded the viewings target; the target now comes from the shared
 * manifest's `aliasOf`.
 */
function NavigateAliasFeature({to}) {
  const params = useParams();
  return <Navigate to={buildPath(to, params)} replace />;
}

NavigateAliasFeature.propTypes = {
  to: PropTypes.string.isRequired,
};

export default NavigateAliasFeature;
